;
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width="24"
    height="24"
  >
    <path
      fill="#374151"
      d="M9 6a1 1 0 000 2V6zm6 2a1 1 0 100-2v2zm-1 9a1 1 0 102 0h-2zm2-3a1 1 0 10-2 0h2zm-4 2a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM9 16a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM9 13a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM12 13a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM15 10a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM12 10a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM9 10a1 1 0 100 2v-2zm.01 2a1 1 0 100-2v2zM7 4h10V2H7v2zm11 1v14h2V5h-2zm-1 15H7v2h10v-2zM6 19V5H4v14h2zm1 1a1 1 0 01-1-1H4a3 3 0 003 3v-2zm11-1a1 1 0 01-1 1v2a3 3 0 003-3h-2zM17 4a1 1 0 011 1h2a3 3 0 00-3-3v2zM7 2a3 3 0 00-3 3h2a1 1 0 011-1V2zm2 6h6V6H9v2zm7 9v-3h-2v3h2zm-4 1h.01v-2H12v2zm-3 0h.01v-2H9v2zm0-3h.01v-2H9v2zm3 0h.01v-2H12v2zm3-3h.01v-2H15v2zm-3 0h.01v-2H12v2zm-3 0h.01v-2H9v2z"
    />
  </svg>
</template>
